import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';
import { toast } from 'react-toastify';

export function* postWithdraw() {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.WITHDRAW,
    });
    const { data } = res;
    yield put({ type: 'POST_WITHDRAW_SUCCESS', data });
    yield call(toast.success, 'Payout request has been successfully registered!');
  } catch (e) {
    yield put({ type: 'POST_WITHDRAW_ERROR' });
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.POST_WITHDRAW, postWithdraw);
}
